module.exports = __webpack_public_path__ + "static/kerryProfile-ff688999135857cb6f163536cfd0e549.png";